import { Mapper } from "../../../../base/utils/mapper";
import { AttentionResumenModel } from "../../../../domain/models/consult/attention-resumen.model";
import { AttentionResumenEntity } from "../entities/attention-resumen.entity";


export class AttentionResumenImplementationRepositoryMapper extends Mapper<AttentionResumenEntity, AttentionResumenModel> {
    mapFrom(param: AttentionResumenEntity): AttentionResumenModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: AttentionResumenModel): AttentionResumenEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}